module.exports = __webpack_public_path__ + "img/129.32096a34.png";